import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';


const defaultOptions = {
    theme: 'bootstrap4',
    iconlib: "fontawesome4",
    disable_collapse: true,
    compact: true,
    no_additional_properties: true,
    disable_edit_json: true,
    disable_properties: true,
    disable_add_remove: true,
}

export default function JsonTableEditor({ options, validation, schema, schemaValues, onChangeJsonEditor, editorId }) {


    useEffect(() => {
        const customOptions = { ...defaultOptions, ...options, schema };
        const element = document.getElementById(editorId);
        const jsonEditor = new window.JSONEditor(element, customOptions);

        jsonEditor.on('change', () => {
            const values = jsonEditor.getEditor(`${options.form_name_root}`).getValue();
            onChangeJsonEditor(values, jsonEditor);
        });


        jsonEditor.on('ready', () => {
            if (schemaValues) jsonEditor.setValue(schemaValues);
            if (validation && typeof validation === 'function'){
                window.JSONEditor.defaults.custom_validators  = [validation];
            } 
        })

        return () => {
            destryoEditor(jsonEditor);
        }

    }, [schemaValues])

    const destryoEditor = jsonEditor => {
        try {
            jsonEditor.destroy();

            // Remove any lingering global validators you pushed
            if (validation && typeof validation === 'function') {
                const index = window.JSONEditor.defaults.custom_validators.indexOf(validation);
                if (index > -1) {
                  window.JSONEditor.defaults.custom_validators.splice(index, 1);
                }
            }
        } catch (e) {
            console.eror("json editor destory error", e)
        }
    }

    return (

        <Grid container spacing={1} xs={12}>
            <Grid item xs={12}>
                <div id={editorId}></div>
            </Grid>
        </Grid>
    )
}